import { Promise } from 'es6-promise'
import commonRequest from 'Api/index'

// state
const state = {
    issueEVoucherQueue: [],
    eVouchers: [],
    voucherStatusStatistics: {},
    voucherHistories: [],
    issueEVoucherRequestList: [],
    voucherCustomerLookup: [],
    voucherUsedList: [],
    voucherCostList: [],
    voucherPromotionList: []
}

// getters
const getters = {
    ISSUE_E_VOUCHER_QUEUE_DATA: state => {
        return state.issueEVoucherQueue
    },
    E_VOUCHER_DATA: state => {
        return state.eVouchers
    },
    VOUCHER_STATUS_STATISTICS_DATA: state => {
        return state.voucherStatusStatistics
    },
    VOUCHER_HISTORY_DATA: state => {
        return state.issueEVoucherRequestList
    },
    E_VOUCHER_LOOKUP_DATA: state => {
        return state.voucherCustomerLookup
    },
    VOUCHER_USED_LIST_DATA: state => {
        return state.voucherUsedList
    },
    VOUCHER_COST_LIST_DATA: state => {
        return state.voucherCostList
    },
    VOUCHER_PROMOTION_LIST_DATA: state => {
        return state.voucherPromotionList
    }
}

// actions
const actions = {
    GET_ISSUE_E_VOUCHER_QUEUE: (context, payload) => {
        return new Promise((resolve, reject) => {
            commonRequest.getRequest(
                process.env.VUE_APP_BACKEND_CORE_URL,
                `/api/v1/0/issue_voucher_queue/`,
                payload,
                function (res) {
                    context.commit('GET_ISSUE_E_VOUCHER_QUEUE_HANDLER', res.data)
                    resolve(res)
                },
                function (error) {
                    reject(error)
                }
            )
        })
    },
    CONFIRM_VOUCHER_ASSIGNED: (context, payload) => {
        return new Promise((resolve, reject) => {
            commonRequest.postRequest(
                process.env.VUE_APP_BACKEND_CORE_URL,
                `/api/v1/0/issue_voucher_queue/confirm_voucher_assigned/`,
                payload,
                function (res) {
                    resolve(res)
                },
                function (error) {
                    reject(error)
                }
            )
        })
    },
    GET_E_VOUCHER_LIST: (context, payload) => {
        return new Promise((resolve, reject) => {
            commonRequest.getRequest(
                process.env.VUE_APP_BACKEND_CUST_URL,
                `/api/v1/customer_evoucher/`,
                payload,
                function (res) {
                    context.commit('GET_E_VOUCHER_LIST_HANDLER', res.data)
                    resolve(res)
                },
                function (error) {
                    reject(error)
                }
            )
        })
    },
    TRANSACTION_FROM_CUSTOMER_TO_CUSTOMER: (context, payload) => {
        return new Promise((resolve, reject) => {
            commonRequest.postRequest(
                process.env.VUE_APP_BACKEND_CORE_URL,
                `/api/v1/0/voucher/transaction/transaction_from_customer_to_customer/`,
                payload,
                function (res) {
                    resolve(res)
                },
                function (error) {
                    reject(error)
                },
                600000
            )
        })
    },
    CONFIRM_VOUCHER_USED_FROM_CUSTOMER: (context, payload) => {
        return new Promise((resolve, reject) => {
            commonRequest.postRequest(
                process.env.VUE_APP_BACKEND_CORE_URL,
                `/api/v1/0/confirm_used_voucher/confirm_voucher_used_from_customer/`,
                payload,
                function (res) {
                    resolve(res)
                },
                function (error) {
                    reject(error)
                }
            )
        })
    },
    VOUCHER_STATUS_STATISTICS: (context, payload) => {
        return new Promise((resolve, reject) => {
            commonRequest.getRequest(
                process.env.VUE_APP_BACKEND_CUST_URL,
                `/api/v1/customer_evoucher/voucher_status_statistics/`,
                payload,
                function (res) {
                    context.commit('VOUCHER_STATUS_STATISTICS_HANDLER', res.data)
                    resolve(res)
                },
                function (error) {
                    reject(error)
                }
            )
        })
    },
    GET_VOUCHER_HISTORY_LIST: (context, payload) => {
        return new Promise((resolve, reject) => {
            commonRequest.getRequest(
                process.env.VUE_APP_BACKEND_CORE_URL,
                `api/v1/0/voucher/history/`,
                payload,
                function (res) {
                    context.commit('GET_VOUCHER_HISTORY_LIST_HANDLER', res.data)
                    resolve(res)
                },
                function (error) {
                    reject(error)
                }
            )
        })
    },
    VOUCHER_USED_LIST: (context, payload) => {
        return new Promise((resolve, reject) => {
            commonRequest.getRequest(
                process.env.VUE_APP_BACKEND_CUST_URL,
                `/api/v1/customer_evoucher/get_voucher_used_list/`,
                payload,
                function (res) {
                    context.commit('VOUCHER_USED_LIST_HANDLER', res.data)
                    resolve(res)
                },
                function (error) {
                    reject(error)
                }
            )
        })
    },
    VOUCHER_COST_LIST: (context, payload) => {
        return new Promise((resolve, reject) => {
            commonRequest.getRequest(
                process.env.VUE_APP_BACKEND_CUST_URL,
                `/api/v1/customer_evoucher/get_cost_voucher_list/`,
                payload,
                function (res) {
                    context.commit('VOUCHER_COST_LIST_HANDLER', res.data)
                    resolve(res)
                },
                function (error) {
                    reject(error)
                }
            )
        })
    },
    LOOKUP_VOUCHER_CUSTOMER: (context, payload) => {
        return new Promise((resolve, reject) => {
            commonRequest.getRequest(
                process.env.VUE_APP_BACKEND_CUST_URL,
                `/api/v1/lookup_voucher_customer/`,
                payload,
                function (res) {
                    context.commit('LOOKUP_VOUCHER_CUSTOMER_HANDLER', res.data)
                    resolve(res)
                },
                function (error) {
                    reject(error)
                }
            )
        })
    },
    SEND_VOUCHER_INFO_TO_EMAIL: (context, payload) => {
        return new Promise((resolve, reject) => {
            commonRequest.postRequest(
                process.env.VUE_APP_BACKEND_CORE_URL,
                `/api/v1/resend_voucher_info/send_voucher_info_to_email/`,
                payload,
                function (res) {
                    resolve(res)
                },
                function (error) {
                    reject(error)
                },
                600000
            )
        })
    },
    SEND_ALL_VOUCHER_INFO_TO_EMAIL: (context, payload) => {
        return new Promise((resolve, reject) => {
            commonRequest.postRequest(
                process.env.VUE_APP_BACKEND_CORE_URL,
                `/api/v1/resend_voucher_info/send_all_voucher_info_to_email/`,
                payload,
                function (res) {
                    resolve(res)
                },
                function (error) {
                    reject(error)
                },
                600000
            )
        })
    },
    CUSTOMER_CONFIRM_USED_VOUCHER: (context, payload) => {
        return new Promise((resolve, reject) => {
            commonRequest.postRequest(
                process.env.VUE_APP_BACKEND_CORE_URL,
                `/api/v1/0/issue_voucher_queue/customer_confirm_used_voucher/`,
                payload,
                function (res) {
                    resolve(res)
                },
                function (error) {
                    reject(error)
                },
                600000
            )
        })
    },
    GET_E_VOUCHER_PROMOTION_LIST: (context, payload) => {
        return new Promise((resolve, reject) => {
            commonRequest.getRequest(
                process.env.VUE_APP_BACKEND_CUST_URL,
                `/api/v1/customer_evoucher/get_voucher_promotion_list/`,
                payload,
                function (res) {
                    context.commit('GET_E_VOUCHER_PROMOTION_LIST_HANDLER', res.data)
                    resolve(res)
                },
                function (error) {
                    reject(error)
                },
                600000
            )
        })
    },
    USED_VOUCHER_PROMOTION: (context, payload) => {
        return new Promise((resolve, reject) => {
            commonRequest.postRequest(
                process.env.VUE_APP_BACKEND_CUST_URL,
                `/api/v1/customer_evoucher/used_voucher_promotion/`,
                payload,
                function (res) {
                    resolve(res)
                },
                function (error) {
                    reject(error)
                },
                600000
            )
        })
    },
    GET_VOUCHERS_OF_VIEWER: (context, payload) => {
        return new Promise((resolve, reject) => {
            commonRequest.getRequestWithoutAuth(
                process.env.VUE_APP_BACKEND_CUST_URL,
                `/api/v1/customer_evoucher/get_vouchers_viewer/`,
                payload,
                function (res) {
                    resolve(res)
                },
                function (error) {
                    reject(error)
                }
            )
        })
    },
    GET_VOUCHERS_INFO_WITH_CODE: (context, payload) => {
        return new Promise((resolve, reject) => {
            commonRequest.getRequestWithoutAuth(
                process.env.VUE_APP_BACKEND_PROD_URL,
                `/api/v1/portal/get_data_not_login/get_voucher_info/`,
                payload,
                function (res) {
                    resolve(res)
                },
                function (error) {
                    reject(error)
                }
            )
        })
    }
}

// mutations
const mutations = {
    GET_ISSUE_E_VOUCHER_QUEUE_HANDLER(state, payload) {
        let results = payload.results
        let page = {
            count: payload.count,
            totalPage: payload.num_pages,
            currentPage: payload.page,
            pageSize: payload.page_size,
            perPage: payload.per_page
        }
        state.issueEVoucherQueue = payload.results ? { results: results, paginate: page } : payload
    },
    GET_E_VOUCHER_LIST_HANDLER: (state, payload) => {
        let eVouchers = payload.results
        let page = {
            count: payload.count,
            totalPage: payload.num_pages,
            currentPage: payload.page,
            pageSize: payload.page_size,
            perPage: payload.per_page
        }
        state.eVouchers = { results: eVouchers, paginate: page }
    },
    VOUCHER_STATUS_STATISTICS_HANDLER: (state, payload) => {
        state.voucherStatusStatistics = payload
    },
    GET_VOUCHER_HISTORY_LIST_HANDLER: (state, payload) => {
        let issueEVoucherRequestList = payload.results
        let page = {
            // count: payload.count,
            totalPage: payload.num_pages,
            currentPage: payload.page,
            pageSize: payload.page_size,
            perPage: payload.per_page
        }

        state.issueEVoucherRequestList = { results: issueEVoucherRequestList, paginate: page }
    },
    LOOKUP_VOUCHER_CUSTOMER_HANDLER: (state, payload) => {
        let eVouchers = payload.results
        let page = {
            count: payload.count,
            totalPage: payload.num_pages,
            currentPage: payload.page,
            pageSize: payload.page_size,
            perPage: payload.per_page
        }
        state.voucherCustomerLookup = { results: eVouchers, paginate: page }
    },
    VOUCHER_USED_LIST_HANDLER: (state, payload) => {
        state.voucherUsedList = payload
    },
    VOUCHER_COST_LIST_HANDLER: (state, payload) => {
        state.voucherCostList = payload
    },
    GET_E_VOUCHER_PROMOTION_LIST_HANDLER: (state, payload) => {
        let eVouchersPromotion = payload.results
        let page = {
            count: payload.count,
            totalPage: payload.num_pages,
            currentPage: payload.page,
            pageSize: payload.page_size,
            perPage: payload.per_page
        }
        state.voucherPromotionList = { results: eVouchersPromotion, paginate: page }
    },
}
export default {
    state,
    getters,
    actions,
    mutations
}